module.exports = __webpack_public_path__ + "static/media/more.bb37cccd.svg";